<template>
    <section class="section">
        <div class="row">
            <div class="col">
                <b-alert :show="vectors.length == 0">
                    Nessun fornitore inserito.
                </b-alert>
                <div v-for="(vector, index) in vectors" :key="index" class="mt-3 mb-5">
                    <label class="form-label">{{ vectorName(vector) }}</label>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Fornitore</th>
                                <th>Dal</th>
                                <th>Al</th>
                                <th class="actions"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(supply, index) in supplies.filter(item => item.vector == vector)" :key="index">
                                <td>{{ supply.supplier }}</td>
                                <td>{{ formatMonth(supply.startDate) }}</td>
                                <td>{{ formatMonth(supply.endDate) }}</td>
                                <td class="actions">
                                    <div class="d-flex">
                                        <b-btn variant="btn btn-warning" v-b-modal.modalSupply @click="showEditForm(supply)">Modifica</b-btn> 
                                        <b-btn variant="btn btn-danger" @click="remove(supply)">Elimina</b-btn> 
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex justify-content-end">
                    <input type="button" class="btn btn-success" value="Aggiungi fornitura" v-b-modal.modalSupply @click="showNewModal()"/>
                </div>
            </div>
        </div>
        <b-modal id="modalSupply" @ok="submit()" ok-title="Salva" centered :title="currentSupply.id ? 'Modifica fornitura' : 'Nuova fornitura'">
            <form role="form">
                <b-row class="mb-4">
                    <b-col class="col-4">
                        <label class="form-label align-self-center mr-3">Fornitore</label>
                    </b-col>
                    <b-col class="col-8">
                        <b-form-select class="form-control" :options="listSuppliers" v-model="currentSupply.supplier" required></b-form-select>
                        <!--<input class="form-control" type="text" v-model="currentSupply.supplier" required />-->
                    </b-col>
                </b-row>
                <b-row class="mb-4">
                    <b-col class="col-4">
                        <label class="form-label align-self-center mr-3">Vettore</label>
                    </b-col>
                    <b-col class="col-8">
                        <b-form-select class="form-control" :options="listVectors" v-model="currentSupply.vector" required></b-form-select>
                    </b-col>
                </b-row>
                <b-row class="mb-4">
                    <b-col class="col-4">
                        <label class="form-label align-self-center mr-3">Data inizio</label>
                    </b-col>
                    <b-col class="col-8">
                        <vue-monthly-picker v-model="startDate"
                            :monthLabels="monthLabels"
                            dateFormat="MM-YYYY" />
                    </b-col>
                </b-row>
                <b-row class="mb-4">
                    <b-col class="col-4">
                        <label class="form-label align-self-center mr-2">Data fine</label>
                    </b-col>
                    <b-col class="col-8">
                        <vue-monthly-picker v-model="endDate"
                            :monthLabels="monthLabels"
                            dateFormat="MM-YYYY" />
                    </b-col>
                </b-row>
            </form>
        </b-modal>
    </section>
</template>

<script>
import api from '@/services/api';
import PageMixin from "../../Charts/PageMixin";
import moment from 'moment';
import { mapGetters } from 'vuex';

    export default {
        name: "Supply",
        props: ["siteId"],
        mixins: [PageMixin],
        data() {
            return {
                supplies: [],
                vectors: [],
                currentSupply: {}, 
                listVectors: [
                    { value: "EE", text: "EE" },
                    { value: "gas", text: "gas" },
                    { value: "olioc", text: "olioc" },
                    { value: "GPL", text: "GPL" },
                    { value: "Diesel", text: "Diesel" },
                    { value: "CDR", text: "CDR" },
                    { value: "spll", text: "spll" },
                    { value: "benz", text: "benz" },
                    { value: "t", text: "t" },
                    { value: "fluidth", text: "fluidth" },
                    { value: "water", text: "water" },
                    { value: "KJF", text: "KJF" },
                ],  
                startDate: "",
                endDate: "",
                listSuppliers: [],
            }
        },
        created() {
            this.$store.commit("loading");
            this.loadSupplies();
            this.loadSuppliers();
            this.$store.commit("stopLoading");
        },
        methods: {
            vectorName(code) {
                return this.$store.getters['vectors/getName'](code)
            },
            async loadSupplies() {
                try {
                    const data = await api().get(`/supply/${this.siteId}`);
                    this.supplies = data.data.data; 
                    this.vectors = [...new Set(this.supplies.map(item => item.vector))]; 
                } catch(e) {
                    this.$notify({
                        type: "error",
                        text: e.message,
                        title: 'Errore',
                    });
                }                
            },
            async loadSuppliers() {
                try {
                    const data = await api().get(`/co2`);
                    this.listSuppliers = data.data.data;
                    this.listSuppliers = this.listSuppliers.map(item => item.supplier);
                } catch(e) {
                    this.$notify({
                        type: "error",
                        text: e.message,
                        title: 'Errore',
                    });
                }
            },
            async submit() {
                try {
                    this.$store.commit("loading");
                    this.currentSupply.startDate = moment(this.startDate).format('YYYYMM');
                    if(this.endDate) {
                        this.currentSupply.endDate = moment(this.endDate).format('YYYYMM');
                    }
                    this.currentSupply.siteId = this.siteId;
                    if(this.currentSupply.id) {
                        await api().patch(`/supply`, this.currentSupply);
                    } else {
                        await api().post('/supply', this.currentSupply);
                    }
                    this.$store.commit("stopLoading");  
                    if(this.currentSupply.id) {
                        this.$notify({
                            type: "success",
                            title: 'Successo',
                            text: "Fornitura modificata con successo"
                        });    
                    } else {
                        this.$notify({
                            type: "success",
                            title: 'Successo',
                            text: "Fornitura creata con successo"
                        });
                    }
                } catch(e) {
                    this.$notify({
                        type: "error",
                        text: e.message,
                        title: 'Errore',
                    });
                }
                this.loadSupplies();
            },
            async remove(supply) {
                this.$swal({
                    title: `Sei sicuro di voler rimuovere ${supply.supplier} ?`,
                    showDenyButton: true,
                    showCancelButton: true,
                    showConfirmButton: false,
                    denyButtonText: "Conferma",
                    cancelButtonText: "Annulla",
                }).then(async (result) => {
                    if(result.isDenied) {
                        try {
                            this.$store.commit("loading");
                            await api().delete(`/supply/${supply.id}`);
                            this.$store.commit("stopLoading");
                            this.$notify({
                                type: "success",
                                title: 'Successo',
                                text: "Fornitura eliminata con successo"
                            });
                        } catch(e) {
                            this.$notify({
                                type: "error",
                                text: e.message,
                                title: 'Errore',
                            });
                        }
                    }
                    this.loadSupplies();
                })
            },
            showNewModal() {
                this.currentSupply = {};
                this.startDate = "";
                this.endDate = "";
            },
            showEditForm(supply) {
                this.currentSupply = supply;
                this.startDate =  moment(supply.startDate.toString()).format("YYYY/MM/DD");
                this.endDate = moment(supply.endDate.toString()).format("YYYY/MM/DD");
            },
            formatMonth(date) {
                if(date != null) {
                    date = moment(date.toString()).format("MM/YYYY");
                }
                return date;
            }
        },
    }
</script>

<style scoped>
    .btn-default {
        background: #999999;
    }
    .actions {
        width: 200px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Admin/Sites/Supply.vue